module.exports = __webpack_public_path__ + "static/media/dth.3345d70c.svg";